export enum FeedbackType {
    Vendor_Information = "Vendor Information",
    Vendor_Document = "Vendor Document",
    Vendor_Contact = "Vendor Contact",
    Vendor_Compliance = "Vendor Compliance",
}
